import * as React from 'react';
import {ChangeEvent} from "react";
import {connect} from "react-redux";
import {signInAction} from "../../actions/auth";


export interface State {
    email: string,
    password: any
}

export interface Props {
    signInAction: any
}

class Login extends React.Component<Props, State> {

    state = {
        email: '',
        password: ''
    };

    handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        this.setState({[name]: value} as any);
    };

    handleSubmit = event => {
        event.preventDefault();
        const data = {
            email: this.state.email,
            password: this.state.password
        };

        this.props.signInAction(data);
    };

    render() {
        return (
            <div>
                <h2>Sign In</h2>
                <form action="" onSubmit={this.handleSubmit} style={{margin: '200px'}}>
                    <input name='email' value={this.state.email} onChange={this.handleChange} style={{ margin: '20px', display: 'block'}} type="text" placeholder="Username"/>
                    <input name='password' value={this.state.password} onChange={this.handleChange} style={{ margin: '20px', display: 'block'}} type="password" placeholder="Password"/>
                    <button style={{ margin: '20px', display: 'block'}}>Sign In</button>
                </form>
            </div>
        );
    }
}

export default connect(null, { signInAction })(Login);



// WEBPACK FOOTER //
// ./src/components/Auth/Login.tsx